import Vue from 'vue';

import template from './index.html';

export default Vue.extend({

  name: 'Tabs',

  template,

  props: {
    name: {
      required: true,
    },
  },

  data() {
    return {
      activeTab: null,
      tabButtons: [],
    };
  },

  methods: {
    defineChildren() {
      this.defineTabButtons();
    },

    defineTabButtons() {
      this.$children.forEach((btn) => {
        const name = btn.$options.name;

        if (name === 'TabButton') {
          this.tabButtons.push(btn);
        }
      });

      this.activeTab = this.tabButtons[0].name;
    },

    setActiveTab(tab) {
      this.activeTab = tab;
    },
  },

  mounted() {
    this.defineChildren();
  },
});



// WEBPACK FOOTER //
// ./src/js/components/tabs/tabs/index.js